
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import ItemForm from './Form.vue';

const invitationCodeApi = api.invitationCode;

@Component({
  components: { ItemForm },
})
export default class InvitationCodeEdit extends Vue {
  private isValueSetted = false;

  private form = {
    invitationCode: null,
    name: null,
    authStatus: null,
    point: null,
    invitationGifts: [],
    isEnabled: null,
    startOn: null,
    endOn: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { invitationCode, ...parameter } = form;
      const { status } = await invitationCodeApi.edit(
        invitationCode,
        parameter,
      );
      this.loading = false;
      if (status === 1) {
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.isValueSetted = true;
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: InvitationCodeEdit) => void) => void,
  ) {
    const { code } = to.params;
    const { data } = await invitationCodeApi.get(code);
    if (data.startOn) {
      data.startOn = moment(data.startOn).format('YYYY-MM-DD');
    }
    if (data.endOn) {
      data.endOn = moment(data.endOn).format('YYYY-MM-DD');
    }
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
